export const useErrorHandler = () => {
  const arrayBufferToString = (buffer) => {
    var byteArray = new Uint8Array(buffer);
    var byteString = '';
    for (var i = 0; i < byteArray.byteLength; i++) {
      byteString += String.fromCodePoint(byteArray[i]);
    }
    return byteString;
  }

  const isApiErrorMessage = (message) => {
    // Example: (001) Invalid DXML file
    const apiErrorCodePattern = /^(\([0-9]+\))/;
    return apiErrorCodePattern.test(message);
  }

  const getMessageFromDataObj = (dataObj, defaultMessage) => {
    if (!dataObj) 
      return defaultMessage;

    let message = defaultMessage;
    if (typeof dataObj.Message === 'string' && isApiErrorMessage(dataObj.Message)) {
      message = dataObj.Message;
    } else if (typeof dataObj.message === 'string' && isApiErrorMessage(dataObj.message)) {
      message = dataObj.message;
    } else if (typeof dataObj.Value === 'string' && isApiErrorMessage(dataObj.Value)) {
      message = dataObj.Value;
    }
    return message;
  }

  const getMessageFromDataArray = (dataArray, defaultMessage) => {
    if (!dataArray) 
      return defaultMessage;

    let message = defaultMessage;
    try {
      const dataString = arrayBufferToString(dataArray);
      if (isApiErrorMessage(dataString)) {
        message = dataString;
      } else {
        const dataObj = JSON.parse(dataString);
        message = getMessageFromDataObj(dataObj);
      }
    } catch (err) {
    }
    return message;
  }

  const handleApiErrorMessage = (error, defaultMessage) => {
    if (!error || !error.response)
      return defaultMessage;

    let message = defaultMessage;
    if (error.response.status === 404) {
      message = "404 Not Found";
    }
    else if (error.response.status === 401) {
      message = "401 Not Authorized";
    }
    else if (error.response.status === 403){
      message = "403 Forbidden";
    }
    else if (error.request.responseType === 'arraybuffer') {
      message = getMessageFromDataArray(error.response.data, defaultMessage);
    }
    else {
      message = getMessageFromDataObj(error.response.data, defaultMessage);
    }
    return message;
  }

  return {
    handleApiError: (error, message, showValidationErrors = false, toastId = null, customErrorHandler, toastHandler) => {
      const errorMessage = handleApiErrorMessage(error, message);

      if (customErrorHandler) {
        customErrorHandler({
          message: errorMessage,
          customErrorMessage: error?.customeErrorMessage,
          validationErrors: error?.validationErrors,
          error: error
        });
      }
      else {
        if (error.customErrorMessage) {
          toastHandler(error.customErrorMessage, 'error');
        }
        else {
          toastHandler(errorMessage, 'error');
        }
      }
    },
    errorHasValidationErrors: (error) => {
      return error.validationErrors
    }
  }
}